import {ServiceInfo} from "../entities/ServiceInfo";
import apiClient from "./http";
import {Response} from "../entities/Response";

export class ServiceInfoService {

    static async listServiceInfo() : Promise<ServiceInfo[]> {
        const response = await apiClient.get('/service/serviceInfo/list');
        return response.data;
    }

    static async createServiceInfo(serviceInfo: ServiceInfo) : Promise<Response<any>> {
        return await apiClient.post('/service/serviceInfo/create', serviceInfo);
    }

    static async updateServiceInfo(serviceInfo: ServiceInfo) : Promise<Response<any>> {
        return await apiClient.post('/service/serviceInfo/update', serviceInfo);
    }

    static async getServiceInfo(request: {appKey: string, env: string}) : Promise<Response<ServiceInfo>> {
        return await apiClient.post('/service/serviceInfo/get', request);
    }
}